import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import moment from "moment";

// Request
import { fetchPayLevelRequest } from "api/payLevel";

class PayLevelDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                payLevelName: null,
                area: null,
                sickLeaveDays: 0,
                vacationLeaveDays: 0,
                createdAt: null,
                updatedAt: null
            }
        }
    };

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchPayLevel(instanceId)
        }
    }

    fetchPayLevel = (id) => {
        fetchPayLevelRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render () {
        const { 
            _id,
            payLevelName,
            area,
            sickLeaveDays,
            vacationLeaveDays,
            createdAt,
            updatedAt
        } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        Pay Level Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goToList('area')}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Pay Level</p>
                            {payLevelName || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Pay Level Area</p>
                            {area ? area.areaName : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Annual Sick Leave</p>
                            {sickLeaveDays || 0} days
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Annual Vacation Leave</p>
                            {vacationLeaveDays || 0} days
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <Button className="btn btn-primary bottom-btn" onClick={() => this.props.goToEditForm('pay-level', _id)}>Edit</Button>
                    </Col>
                </Row>
            </Grid>
        )
    }

}

export default PayLevelDetails;
